


import React, { useState, useEffect } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import TableIconModal from "../../../shares/TableIconModal";
import CreateOrderCard from "../../../shares/CreateOrderCard";
import OrderCardLeftPart from "../../create-order/OrderCardLeftPart";
import ReturnOrderCardLeftPart from "./ReturnOrderCardLeftPart";

// import JS files


const ReturedOrderAddRing = (props) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <TableIconModal
        width="w-11/12"
        icon={<AddCircleIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <CreateOrderCard ring={props.selectedRow}>
          <ReturnOrderCardLeftPart
            item={props.selectedRow}
            hasOpenModal
            AddRing={props.AddRing}
            setOpenModal={setOpenModal}
            selectedUser={props.selectedUser}
          />
        </CreateOrderCard>
      </TableIconModal>
    </>
  );
};

export default ReturedOrderAddRing;
